"use client";

import React from "react";
import { MapPin, Phone, Navigation, Clock } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FindUsInTheCity() {
  const {
    ref: cardRef,
    isVisible: isCardVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223680" id="find-us-in-the-city" className="relative w-full min-h-[600px] flex items-center bg-background overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687484/img/city_pet_care_location_map.png)] bg-cover bg-center bg-no-repeat grayscale opacity-40 mix-blend-multiply" />
        {}
        <div className="absolute inset-0 bg-gradient-to-r from-background/90 via-background/40 to-transparent" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div ref={cardRef} className={`max-w-md transition-all duration-1000 ease-out ${isCardVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Card className="bg-card backdrop-blur-xl border-border/50 shadow-xl overflow-hidden rounded-lg">
            <CardHeader className="pb-4">
              <Badge variant="secondary" className="w-fit mb-3 bg-accent text-accent-foreground font-sans">
                Validated Parking in Rear
              </Badge>
              <CardTitle className="text-3xl font-default text-foreground tracking-tight">
                Find Us in the City
              </CardTitle>
              <CardDescription className="text-base font-sans text-muted-foreground mt-2 leading-relaxed">
                Visit City Pet Care for compassionate veterinary services in the heart of the urban oasis.
              </CardDescription>
            </CardHeader>

            <CardContent className="space-y-5 pb-6">
              <div className="flex items-start gap-4">
                <div className="mt-1 bg-accent p-2 rounded-md shrink-0">
                  <MapPin className="w-5 h-5 text-ring" />
                </div>
                <div>
                  <h4 className="font-default font-semibold text-foreground">
                    Our Clinic
                  </h4>
                  <p className="text-muted-foreground font-sans mt-1 leading-relaxed">
                    742 Urban Avenue
                    <br />
                    Metropolis, NY 10012
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="mt-1 bg-accent p-2 rounded-md shrink-0">
                  <Phone className="w-5 h-5 text-ring" />
                </div>
                <div>
                  <h4 className="font-default font-semibold text-foreground">
                    Emergency Contact
                  </h4>
                  <p className="text-destructive font-sans font-medium mt-1">
                    (555) 911-PETS
                  </p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="mt-1 bg-accent p-2 rounded-md shrink-0">
                  <Clock className="w-5 h-5 text-ring" />
                </div>
                <div>
                  <h4 className="font-default font-semibold text-foreground">
                    Clinic Hours
                  </h4>
                  <p className="text-muted-foreground font-sans mt-1">
                    Mon-Sat: 8am - 8pm
                  </p>
                </div>
              </div>
            </CardContent>

            <CardFooter className="pt-2 pb-6">
              <Button asChild size="lg" className="w-full group bg-primary hover:bg-primary/90 text-primary-foreground rounded-lg transition-transform hover:scale-[1.02]">
                <Link to="https://maps.google.com/?q=742+Urban+Avenue,+Metropolis,+NY+10012" newTab>
                  <Navigation className="w-4 h-4 mr-2 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                  Get Directions
                </Link>
              </Button>
            </CardFooter>
          </Card>
        </div>
      </div>
    </section>;
}